export default __webpack_public_path__ + "static/media/07.fa6e261c.jpg";